<div class="homeuser-wrapper">
    <div class="hero card-glass mb-3">
        <div class="crumb">
            <a routerLink="/utilisateur/espace-client" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour a l'espace client</a>
            <span class="crumb-current">Codes & espaces pro</span>
        </div>
        <div class="hero-flex">
            <div>
                <p class="eyebrow">Spay · Codes et retraits sécurisés</p>
                <h1>Bonjour {{connectedUser?.firstname || firstname}}</h1>
                <p class="lead">Générez vos codes, suivez vos espaces pro et renforcez la sécurité de votre compte.</p>

                <div class="pill-row">
                    <span class="pill">Compte : {{displayPrimaryAccountNumber|slice:0:3}}
                        {{displayPrimaryAccountNumber|slice:3:6}}
                        {{displayPrimaryAccountNumber|slice:6:9}}</span>
                    <span class="pill pill-strong">Solde : {{displayPrimaryAccountBalance| currency:sigle}}</span>
                </div>

                <div class="alerts">
                    <p *ngIf="!(connectedUser?.secure ?? secure)" class="alert-text warn">Sécurisez votre compte <a
                            routerLink="/informations/personel">ici</a>.</p>
                    <p *ngIf="!(connectedUser?.confirmphone ?? confirmphone) || !(connectedUser?.confirmCNi ?? confirmCNi)"
                        class="alert-text warn">
                        Finalisez votre identification <a routerLink="/utilisateurs/identification">ici</a>.</p>
                    <p *ngIf="phoneNotConfirm" class="alert-text danger">Vous devez confirmer votre numéro de téléphone.
                    </p>
                    <p *ngIf="!(connectedUser?.confirmCNi ?? confirmCNi)" class="alert-text danger">Identité non
                        confirmée ou en cours de
                        confirmation.</p>
                </div>
            </div>
            <div class="hero-side">
                <div class="side-card">
                    <p class="side-label">Code de paiement (CDP)</p>
                    <p class="side-value">{{pincode || '—'}}</p>
                    <button class="btn btn-primary btn-sm btn-pill mt-2" (click)="getpincode()">Générer</button>
                </div>
                <div class="side-card">
                    <p class="side-label">Code de retrait (CDR)</p>
                    <p class="side-value">{{pincodeRetait || '—'}}</p>
                    <button class="btn btn-outline-light btn-sm btn-pill mt-2"
                        (click)="getpincodeRetrait()">Générer</button>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-glass border-0 mb-3">
        <div class="card-body">
            <div class="d-flex flex-wrap justify-content-between align-items-start gap-2">
                <div>
                    <p class="eyebrow mb-1">Espace Professionnel</p>
                    <h4 class="mb-1 text-light">Créez ou éditez vos espaces pro</h4>
                    <p class="text-light opacity-75 mb-2">Encaissez, gérez vos vitrines et générez des codes pro en
                        quelques étapes.</p>
                    <div class="alerts">
                        <p *ngIf="sucessMessage" class="alert-text warn">Votre espace Professionel a été créé.</p>
                        <p *ngIf="sucessMessageEdit" class="alert-text warn">Les modifications ont été effectuées.</p>
                        <p *ngIf="islimit" class="alert-text danger">Vous avez atteint le maximum de comptes
                            professionnels autorisé.</p>
                    </div>
                </div>
                <div class="d-flex gap-2">
                    <button type="button" class="btn btn-outline-light btn-pill"
                        (click)="getBussnessAccount()">Rafraîchir</button>
                    <button type="button" class="btn btn-primary btn-pill" data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasPro" (click)="startCreate()">Créer un espace pro</button>
                </div>
            </div>
            <div class="mt-2" *ngIf="loader">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <span>Traitement en cours…</span>
            </div>
        </div>
    </div>

    <div class="card-glass p-3">
        <p class="eyebrow mb-1">Vitrines</p>
        <h4 class="mb-3">Vos comptes professionnels</h4>
        <ng-container *ngIf="baccountList?.length; else noBusiness">
            <div class="row">
                <div class="col-sm-12 col-xl-4 col-lg-4 col-md-12 border-0 mb-2"
                    *ngFor="let b of baccountList; index as i">
                    <div class="card cardlogin mt-2 border-0 h-100 mb-3">
                        <div class="card-header generalbgColorV2 border-0 text-center text-white font-weight-bolder">
                            {{b.nomEntreprise}}</div>
                        <div class="card-body">
                            <ul class="list-group ">
                                <li class=" list-group-item d-flex justify-content-between align-items-center border-0">
                                    Numéro de compte
                                    <span class="badge badge-success badge-pill"
                                        style="font-size: 16px;">{{b.accountNumber|slice:0:3}}
                                        {{b.accountNumber|slice:3:6}} {{b.accountNumber|slice:6:10}}</span>
                                </li>
                                <li class=" list-group-item d-flex justify-content-between align-items-center border-0">
                                    solde
                                    <span class="badge badge-secondary badge-pill"
                                        style="font-size: 16px;">{{b.accountBalance | currency:sigle}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center border-0">
                                    gestionnaire
                                    <span
                                        class="badge badge-secondary badge-pill font-weight-bolder">{{b.nomGestionnaire}}
                                        {{b.prenomGestionaire}}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center border-0">
                                    <button class="btn btn-secondary  btn-sm text-white" [disabled]="!b.enable"
                                        (click)="getpincodeRetraitProfessionel(i,b.accountNumber)" id="{{i}}">code
                                        Professionel</button>
                                    <span class="text-white" id="{{b.accountNumber}}"></span>
                                </li>
                            </ul>
                        </div>
                        <div class="card-footer  generalbgColor text-success">
                            <div>
                                <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                                    <button type="button" class="btn btn-sm btn-secondary" [disabled]="!b.enable"
                                        (click)="b.enable && GoToAddCaissier(b.nomEntreprise,b.id)">
                                        <i class="bi bi-person-badge mr-2"></i>caissier
                                    </button>

                                    <button type="button" class="btn btn-secondary" [disabled]="!b.enable"
                                        (click)="b.enable && GoTobSpace(b.nomEntreprise,b.id)">
                                        <i class="bi bi-arrow-right mr-2"></i>entré
                                    </button>

                                    <button type="button" class="btn btn-secondary" [disabled]="!b.enable"
                                        (click)="b.enable && editVitrine(b)">
                                        <i class="bi bi-pencil-square mr-2"></i>editer
                                    </button>

                                    <button type="button" class="btn btn-secondary" [disabled]="!b.enable"
                                        (click)="b.enable && GoTobSpaceTransaction(b.nomEntreprise,b.accountNumber)">
                                        <i class="bi bi-arrow-right mr-2"></i>activités
                                    </button>

                                    <button *ngIf="b.accountBalance == 0" type="button" class="btn btn-outline-danger"
                                        [disabled]="!b.enable" (click)="b.enable && removeAccount(b.id)">
                                        <i class="bi bi-trash mr-2"></i>
                                    </button>
                                </div>
                            </div>
                            <div>
                                <span *ngIf="!b.enable" class="badge bg-warning text-dark ms-2">
                                    En cours d'activation...
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </ng-container>
        <ng-template #noBusiness>
            <div class="card cardlogin border-0 mt-3">
                <div class="card-header generalbgColorV2 border-0 text-center text-white font-weight-bolder">
                    En cours de vérification</div>
                <div class="card-body">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">Nous effectuons les premières vérifications à l'aide de votre NIU.
                        </li>
                        <li class="list-group-item">Nous activons votre caisse si les premières vérifications sont
                            satisfaisantes.</li>
                        <li class="list-group-item">Nous effectuons une localisation de votre structure.</li>
                        <li class="list-group-item">Nous nous réservons le droit de suspendre votre compte si la
                            localisation échoue ou pour tout autre raison non conforme à nos règles d'utilisation.</li>
                    </ul>
                </div>
            </div>
        </ng-template>
    </div>
</div>

<div class="offcanvas offcanvas-end offcanvas-glass" tabindex="-1" id="offcanvasPro"
    aria-labelledby="offcanvasProLabel">
    <div class="offcanvas-header">
        <div>
            <p class="eyebrow mb-1">Spay Pro</p>
            <h5 class="mb-0" id="offcanvasProLabel">{{ isEditVitrine ? 'Modifier un espace pro' : 'Créer un espace pro'
                }}</h5>
        </div>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"
            (click)="closeProDrawer()"></button>
    </div>
    <div class="offcanvas-body">
        <div class="stepper mb-3">
            <div *ngFor="let label of stepLabels; let idx = index" class="step-item" [class.active]="stepIndex >= idx">
                <div class="dot"></div>
                <span>{{label}}</span>
            </div>
        </div>
        <div class="progress mb-3 bg-dark" style="height:6px;">
            <div class="progress-bar bg-primary" role="progressbar" [style.width.%]="progressPercent()"></div>
        </div>

        <form [formGroup]="entreprise" (ngSubmit)="onSaveEntreprise(entreprise.value)">
            <ng-container [ngSwitch]="stepIndex">
                <div *ngSwitchCase="0" class="row g-3">
                    <div class="col-md-12">
                        <label class="form-label">Entreprise / Raison sociale</label>
                        <input class="form-control" formControlName="nomEntreprise" placeholder="Ex: Boutique K&M">
                        <small class="text-danger"
                            *ngIf="nomEntreprise.invalid && (nomEntreprise.dirty || nomEntreprise.touched)">Champ
                            obligatoire (3-30 caractères)</small>
                    </div>
                    <div class="col-md-12">
                        <label class="form-label">Numéro identifiant unique (NIU)</label>
                        <input class="form-control" formControlName="numero" placeholder="NIU">
                    </div>
                </div>

                <div *ngSwitchCase="1" class="row g-3">
                    <div class="col-md-4">
                        <label class="form-label">Téléphone gestionnaire</label>
                        <input class="form-control" formControlName="telephoneGestionnaire" placeholder="6X XX XX XX">
                        <small class="text-danger"
                            *ngIf="telephoneGestionnaire.invalid && (telephoneGestionnaire.dirty || telephoneGestionnaire.touched)">Téléphone
                            requis (format local)</small>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Nom du gestionnaire</label>
                        <input class="form-control" formControlName="nomGestionnaire" placeholder="Nom">
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Prénom du gestionnaire</label>
                        <input class="form-control" formControlName="prenomGestionaire" placeholder="Prénom">
                    </div>
                </div>

                <div *ngSwitchCase="2" class="row g-3">
                    <div class="col-md-6">
                        <label class="form-label">Ville</label>
                        <input class="form-control" formControlName="ville" placeholder="Ville">
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Quartier</label>
                        <input class="form-control" formControlName="quartier" placeholder="Quartier">
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Type d’activité</label>
                        <select class="form-control" formControlName="typ">
                            <option value="">Choisir</option>
                            <option value="1">Standard</option>
                            <option value="2">Commerce en ligne</option>
                        </select>
                    </div>
                </div>

                <div *ngSwitchCase="3" class="review card-glass p-3">
                    <h6 class="mb-2">Résumé</h6>
                    <div class="review-row"><span>Entreprise</span><strong>{{entreprise.value.nomEntreprise ||
                            '—'}}</strong></div>
                    <div class="review-row"><span>NIU</span><strong>{{entreprise.value.numero || '—'}}</strong></div>
                    <div class="review-row"><span>Gestionnaire</span><strong>{{entreprise.value.nomGestionnaire}}
                            {{entreprise.value.prenomGestionaire}}</strong></div>
                    <div class="review-row">
                        <span>Téléphone</span><strong>{{entreprise.value.telephoneGestionnaire}}</strong>
                    </div>
                    <div class="review-row"><span>Ville / Quartier</span><strong>{{entreprise.value.ville}}
                            {{entreprise.value.quartier}}</strong></div>
                    <div class="review-row"><span>Type</span><strong>{{entreprise.value.typ == '2' ? 'Commerce en ligne'
                            : 'Standard'}}</strong></div>
                </div>
            </ng-container>

            <div class="d-flex justify-content-between align-items-center mt-3">
                <button type="button" class="btn btn-outline-light btn-pill" (click)="prevStep()"
                    [disabled]="stepIndex === 0">Précédent</button>
                <div class="d-flex gap-2">
                    <button type="button" class="btn btn-primary btn-pill" *ngIf="stepIndex < stepLabels.length - 1"
                        [disabled]="!stepValid()" (click)="nextStep()">Continuer</button>
                    <button type="submit" class="btn btn-primary btn-pill" *ngIf="stepIndex === stepLabels.length - 1"
                        [disabled]="!entreprise.valid || loader">{{ isEditVitrine ? 'Mettre à jour' :
                        'Enregistrer'}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
